import React, {PureComponent} from 'react';
import $ from "jquery";
import {formatTime} from "../functions/utils";
import parallel from "async/parallel";
import {
    confirmIdentity,
    connectSocket,
    subscribeDashToServer,
    subscribeToStandingsInfo,
    closeSocket
} from "../functions/api";

import {withTranslation} from "react-i18next";
import {withCookies} from "react-cookie";

const serverIP = process.env.REACT_APP_SERVER_IP;
const backendPort = process.env.REACT_APP_BACKEND_PORT;

// Counter to update car list
let counter = 0;

class PopoutLiveTiming extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            categoryList: [],
            tableRows: [],
            sectors: [],
            sessionDetails: {},
            carList: [],
            currentFilter: -1,
            currentDivision: "P",
            bestLapOverall: 0,
            hoverArray: [],
            confirmedOrg: true,
            standings: [],
            bestPartials: [],
            bestSectors: [],
            bestTimes: [],
            bestPartialsOverall: [],
            bestSectorsOverall: [],
        };

        this.getCircuitDetails = this.getCircuitDetails.bind(this);
        this.makeTableRows = this.makeTableRows.bind(this);
        this.getSessionDetails = this.getSessionDetails.bind(this);
        this.getCarList = this.getCarList.bind(this);
        this.getCategoryList = this.getCategoryList.bind(this);
        this.handleChangeFilter = this.handleChangeFilter.bind(this);
        this.handleChangeDivisions = this.handleChangeDivisions.bind(this);
        this.handleAddToHover = this.handleAddToHover.bind(this);
        this.getBestPartialTimes = this.getBestPartialTimes.bind(this);

        this.evaluateTime = this.evaluateTime.bind(this);
    }

    /* LIFE CYCLE */
    componentDidMount() {
        $('.loading').fadeIn();
        const helper = this;
        confirmIdentity(this.props.cookies.get("authToken"), this.props.match.params.userID, this.props.match.params.eventID, (confirmed) => {
            if (confirmed) {
                // Connect Socket
                connectSocket(this.props.cookies.get("authToken"), null, this.props.match.params.sessionID, this.props.match.params.eventID, "LIVETIMING", (msg) => {
                    console.log("[LIVE TIMING]" + msg);
                    // DS
                    subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
                        console.log("[LIVE TIMING.JS]DEDICATED STREAM SUBSCRIBED");

                        parallel([
                            function (p_callback) {
                                helper.getCircuitDetails((status) => {
                                    p_callback(null, status);
                                });
                            },
                            function (p_callback) {
                                helper.getSessionDetails((status) => {
                                    p_callback(null, status);
                                });
                            },
                            function (p_callback) {
                                helper.getCarList((status) => {
                                    p_callback(null, status);
                                });
                            },
                            function (p_callback) {
                                helper.getCategoryList((status) => {
                                    p_callback(null, status);
                                });
                            },
                            function (p_callback) {
                                helper.getBestPartialTimes((status) => {
                                    p_callback(null, status);
                                });
                            },
                        ], function (err, callback) {
                            // Subscribe to standings info
                            subscribeToStandingsInfo(helper.props.match.params.eventID, false, (err, standings) => {
                                counter++;
                                // Update session's overall Best Lap
                                helper.setState({
                                    bestLapOverall: standings.obl,
                                    standings: standings,
                                });
                                helper.makeTableRows(standings);
                            });
                        });
                    });
                });
            } else {
                this.setState({
                    confirmedOrg: false,
                });
            }
        });
    }

    componentWillUnmount() {
        subscribeDashToServer(this.props.match.params.eventID, this.props.match.params.sessionID, () => {
            console.log("[DASHBOARD] DEDICATED STREAM UNSUBSCRIBED");
        });
        subscribeToStandingsInfo(this.props.match.params.eventID, true, null);
        closeSocket();
    }

    /* GET DATA */
    getSessionDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSessionDetails',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    sessionDetails: data,
                }, () => {
                    console.log("[LIVE TIMING.JS] COMPLETE getSessionDetails");
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getCircuitDetails(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ':' + backendPort + '/dashboard/getSectorInfo',
            dataType: 'json',
            headers: {
                'authorization': helper.props.cookies.get("authToken")
            },
            data: {
                sessionID: helper.props.match.params.sessionID
            },
            success: function (data) {
                helper.setState({
                    sectors: data,
                }, () => {
                    console.log("[LIVE TIMING.JS] COMPLETE getCircuitDetails");
                    callback("ok");
                });
            },
            error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getCarList(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getCarListLive',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                for (let i = 0; i < data.length; i++) {
                    data[i]["splits"] = [];
                }
                helper.setState({
                    carList: data,
                }, () => {
                    console.log("[LIVE TIMING.JS] COMPLETE getCarList");
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                helper.setState({
                    carList: []
                }, () => {
                    callback("nok");
                });
            }
        });
    }

    getCategoryList(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getRatingList',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    categoryList: data,
                }, () => {
                    console.log("[LIVE TIMING.JS] COMPLETE getCategoryList");
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    getBestPartialTimes(callback) {
        const helper = this;
        $.ajax({
            type: 'POST',
            url: serverIP + ":" + backendPort + '/dashboard/getBestPartialTimes',
            headers: {
                'authorization': helper.props.cookies.get("authToken"),
            },
            data: {
                sessionID: helper.props.match.params.sessionID,
            },
            success: function (data) {
                helper.setState({
                    bestTimes: data[0],
                    bestPartialsOverall: data[1],
                    bestSectorsOverall: data[2],
                }, () => {
                    console.log("[LIVE TIMING.JS] COMPLETE getBestPartialTimes");
                    callback("ok");
                });
            }, error: function (err) {
                if (err) {
                    console.error('Error:', err);
                }
                callback("nok");
            }
        });
    }

    /* HANDLERS */
    evaluateTime(currentTime, edr_id, order_no) {
        let temp = this.state.bestTimes.slice();
        for (let i = 0; i < temp.length; i++) {
            if (temp[i].id === edr_id) {
                if (
                    temp[i][this.state.currentDivision === "P" ? "best_splits" : "best_sectors"][order_no] &&
                    temp[i][this.state.currentDivision === "P" ? "best_splits" : "best_sectors"][order_no] >= currentTime &&
                    currentTime > 0
                ) {
                    temp[i][this.state.currentDivision === "P" ? "best_splits" : "best_sectors"][order_no] = currentTime;

                    // Check if is best overall
                    if (temp[i][this.state.currentDivision === "P" ? "best_splits" : "best_sectors"][order_no]) {
                        if (this.state.currentDivision === "P") {
                            if (this.state.bestPartialsOverall[order_no] >= currentTime) {
                                let temp = this.state.bestPartialsOverall.slice();
                                temp[order_no] = currentTime;
                                this.setState({
                                    bestPartialsOverall: temp,
                                });
                                return "overall-best-partial";
                            } else {
                                return "best-partial";
                            }
                        } else {
                            if (this.state.bestSectorsOverall[order_no] >= currentTime) {
                                let temp = this.state.bestSectorsOverall.slice();
                                temp[order_no] = currentTime;
                                this.setState({
                                    bestSectorsOverall: temp,
                                });
                                return "overall-best-partial";
                            } else {
                                return "best-partial";
                            }
                        }
                    }
                } else {
                    return "";
                }
            }
        }
        return "";
    }

    handleAddToHover(event, carID) {
        if (this.state.hoverArray.includes(carID)) {
            for (let i = 0; i < this.state.hoverArray.length; i++) {
                if (this.state.hoverArray[i] === carID) {
                    this.state.hoverArray.splice(i, 1);
                    $(event.target.parentElement).removeClass("forceHover");
                    break;
                }
            }
        } else {
            $(event.target.parentElement).addClass("forceHover");
            this.state.hoverArray.push(carID);
        }
    }

    handleChangeFilter(e) {
        e.preventDefault();
        this.setState({
            currentFilter: e.target.value,
        });
    }

    handleChangeDivisions(e) {
        e.preventDefault();
        this.setState({
            currentDivision: (e.target.value === "S" ? "S" : "P"),
            tableRows: [],
        });
    }

    /* RENDER */
    makeTableRows(newList) {
        if (this.state.sessionDetails.length > 0 && this.state.carList.length > 0 && this.state.sectors.length > 0) {

            let standings = newList.std;
            let rows = [];

            for (let pos = 0; pos < standings.length; pos++) {
                let car = -1;
                for (let c = 0; c < this.state.carList.length; c++) {
                    if (standings[pos].cid === this.state.carList[c].id) {
                        let tempList = this.state.carList.slice();
                        tempList[c].splits[standings[pos].lsn] = standings[pos].lss;
                        this.setState({
                            carList: tempList,
                        });
                        car = c;
                        break;
                    }
                }
                if (car < 0) {
                    continue;
                }

                // Current car index            -> car
                // Current car standing index   -> pos

                // Clear splits if new lap
                if (standings[pos].lsn === 0) {
                    let temp = this.state.carList[car].splits[0];
                    let tempList = this.state.carList.slice();
                    tempList[car].splits = [];
                    tempList[car].splits[0] = temp;
                    this.setState({
                        carList: tempList,
                    });
                    if (counter > 15) {
                        counter = 0;
                        //this.getCarList();
                    }
                }

                // On-Going lap
                let splits = [];
                if (this.state.currentDivision === "S") {
                    let S1 = 0;
                    let S2 = 0;
                    let S3 = 0;

                    if (
                        this.state.carList[car].splits[this.state.sectors[0].order_no] &&
                        this.state.carList[car].splits[this.state.sectors[1].order_no] &&
                        this.state.carList[car].splits[this.state.sectors[2].order_no]
                    ) {
                        S1 = this.state.carList[car].splits[this.state.sectors[0].order_no] + this.state.carList[car].splits[this.state.sectors[1].order_no] + this.state.carList[car].splits[this.state.sectors[2].order_no];
                    } else {
                        S1 = -1;
                    }
                    if (
                        this.state.carList[car].splits[this.state.sectors[3].order_no] &&
                        this.state.carList[car].splits[this.state.sectors[4].order_no] &&
                        this.state.carList[car].splits[this.state.sectors[5].order_no]
                    ) {
                        S2 = this.state.carList[car].splits[this.state.sectors[3].order_no] + this.state.carList[car].splits[this.state.sectors[4].order_no] + this.state.carList[car].splits[this.state.sectors[5].order_no];
                    } else {
                        S2 = -1;
                    }
                    if (
                        this.state.carList[car].splits[this.state.sectors[6].order_no] &&
                        this.state.carList[car].splits[this.state.sectors[7].order_no] &&
                        this.state.carList[car].splits[this.state.sectors[8].order_no] &&
                        this.state.carList[car].splits[this.state.sectors[9].order_no]
                    ) {
                        S3 = this.state.carList[car].splits[this.state.sectors[6].order_no] + this.state.carList[car].splits[this.state.sectors[7].order_no] + this.state.carList[car].splits[this.state.sectors[8].order_no] + this.state.carList[car].splits[this.state.sectors[9].order_no];
                    } else {
                        S3 = -1;
                    }
                    splits = [
                        (<td key={this.state.carList[car] + "_S1"} className={this.evaluateTime(S1, this.state.carList[car].edr_id, 0)} style={{width: "20%", fontSize: 20}}>
                            {S1 > 0 ? (S1 / 1000).toFixed(3) : "---"}
                        </td>),
                        (<td key={this.state.carList[car] + "_S2"} className={this.evaluateTime(S2, this.state.carList[car].edr_id, 1)} style={{width: "20%", fontSize: 20}}>
                            {S2 > 0 ? (S2 / 1000).toFixed(3) : "---"}
                        </td>),
                        (<td key={this.state.carList[car] + "_S3"} className={this.evaluateTime(S3, this.state.carList[car].edr_id, 2)} style={{width: "20%", fontSize: 20}}>
                            {S3 > 0 ? (S3 / 1000).toFixed(3) : "---"}
                        </td>),
                    ];
                } else {
                    for (let sec = 0; sec < this.state.sectors.length; sec++) {
                        if (this.state.carList[car].splits[this.state.sectors[sec].order_no]) {
                            splits.push(
                                <td key={this.state.carList[car].id + "_" + this.state.sectors[sec].order_no}
                                    className={this.evaluateTime(this.state.carList[car].splits[this.state.sectors[sec].order_no], this.state.carList[car].edr_id, this.state.sectors[sec].order_no)}
                                    style={{width: "6%"}}
                                >
                                    {(this.state.carList[car].splits[this.state.sectors[sec].order_no] / 1000).toFixed(3)}
                                </td>
                            );
                        } else {
                            splits.push(
                                <td key={this.state.carList[car].id + "_" + this.state.sectors[sec].order_no} style={{width: "6%"}}>
                                    ---
                                </td>
                            );
                        }
                    }
                }

                if (parseInt(this.state.currentFilter) === -1 || parseInt(this.state.carList[car].car_rating_id) === parseInt(this.state.currentFilter)) {
                    rows.push(
                        <tr
                            key={this.state.carList[car].livery_number}
                            className={"onHover App_white_text" + (this.state.hoverArray.includes(this.state.carList[car].id) ? " forceHover" : "")}
                            style={{textAlign: "center"}}
                            onClick={(event) => this.handleAddToHover(event, this.state.carList[car].id)}
                        >
                            <td>
                                {pos + 1}
                            </td>
                            <td>
                                {standings[pos].lct}
                            </td>
                            <td>
                                {this.state.carList[car].car_rating}
                            </td>
                            <td>
                                <b>#{this.state.carList[car].livery_number}</b> {this.state.carList[car].team_name}
                            </td>
                            <td>
                                {this.state.carList[car].car_class}
                            </td>
                            {splits}
                            <td>
                                {standings[pos].llt ? formatTime(standings[pos].llt) : "---"}
                            </td>
                            <td style={{color: (parseInt(this.state.bestLapOverall) === parseInt(standings[pos].blt) ? "#ff00e4" : (this.state.hoverArray.includes(this.state.carList[car].id) ? "#000000" : "#FFFFFF")),}}>
                                {standings[pos].blt ? formatTime(standings[pos].blt) : "---"}
                            </td>
                        </tr>
                    );
                }
            }

            this.setState({
                tableRows: rows,
            }, () => {
                $('.loading').fadeOut();
            });
        }
    }

    render() {
        if (this.state.confirmedOrg) {
            return (
                <div className={"container-fluid"}>
                    <div className={"row row-flex"}>
                        <div className={"col-xs-12 col-md-10 App_categoryHeader"}>
                            <div className={"col-xs-12 col-md-2 App_title"}>
                                {this.props.t("categoryFilter").toUpperCase()}
                            </div>
                            <div className={"col-xs-12 col-md-10"}>
                                <button
                                    style={{
                                        color: (parseInt(this.state.currentFilter) === -1 ? "#FFFFFF" : "#000000"),
                                        backgroundColor: (parseInt(this.state.currentFilter) === -1 ? "#ed2126" : "#FFFFFF"),
                                    }}
                                    value={-1}
                                    className={"btn App_liveTiming_btn"}
                                    onClick={this.handleChangeFilter}
                                >
                                    {this.props.t("allVehicles").toUpperCase()}
                                </button>
                                {this.state.categoryList.map((category) => {
                                    return (
                                        <button
                                            key={category.id}
                                            style={{
                                                color: (parseInt(this.state.currentFilter) === category.id ? "#FFFFFF" : "#000000"),
                                                backgroundColor: (parseInt(this.state.currentFilter) === category.id ? "#ed2126" : "#FFFFFF"),
                                            }}
                                            className={"btn App_liveTiming_btn"}
                                            value={category.id}
                                            onClick={this.handleChangeFilter}
                                        >
                                            {category.description}
                                        </button>
                                    );
                                })}
                            </div>
                        </div>
                        <div className={"col-xs-12 col-md-2 App_viewTypeHeader"}>
                            <button
                                style={{
                                    backgroundColor: (this.state.currentDivision === "S" ? "#ed2126" : "#ffffff"),
                                    color: (this.state.currentDivision === "S" ? "#ffffff" : "#000000"),
                                }}
                                className={"btn App_liveTiming_btn"}
                                value={"S"}
                                onClick={this.handleChangeDivisions}
                            >
                                {this.props.t("sectors").toUpperCase()}
                            </button>
                            <button
                                style={{
                                    backgroundColor: (this.state.currentDivision === "P" ? "#ed2126" : "#ffffff"),
                                    color: (this.state.currentDivision === "P" ? "#ffffff" : "#000000"),
                                }}
                                className={"btn App_liveTiming_btn"}
                                value={"P"}
                                onClick={this.handleChangeDivisions}
                            >
                                {this.props.t("partials").toUpperCase()}
                            </button>
                        </div>
                    </div>
                    <div className={"row"}>
                        <div className={"table-responsive App_lapTableContainerStyle table-scroll-parent"} style={{height: "90vh"}}>
                            <div className="loading">
                                <div className={"loading-text hidden-sm hidden-xs"}>{this.props.t("processing")}</div>
                            </div>
                            <div className={"table-scroll-child"}>
                                <table className={"table table-hover table-condensed"}>
                                    <thead>
                                    <tr>
                                        <th className={"App_header"} style={{width: "2%"}}>Pos</th>
                                        <th className={"App_header"} style={{width: "2%"}}>{this.props.t("lap")}</th>
                                        <th className={"App_header"} style={{width: "5%"}}>{this.props.t("rating")}</th>
                                        <th className={"App_header"} style={{width: "10%"}}>{this.props.t("vehicle")}</th>
                                        <th className={"App_header"} style={{width: "5%"}}>{this.props.t("class")}</th>
                                        {this.state.currentDivision === "S" ? (
                                            <>
                                                <th className={"App_header_background"} style={{width: "20%", whiteSpace: "nowrap"}}>S1</th>
                                                <th className={"App_header_background"} style={{width: "20%", whiteSpace: "nowrap"}}>S2</th>
                                                <th className={"App_header_background"} style={{width: "20%", whiteSpace: "nowrap"}}>S3</th>
                                            </>
                                        ) : (
                                            this.state.sectors.map((sector) => {
                                                return (
                                                    <th key={sector.order_no} className={"App_header_background"} style={{whiteSpace: "nowrap", width: "6%"}}>P {parseInt(sector.order_no) + 1}</th>
                                                );
                                            })
                                        )}
                                        <th className={"App_header"} style={{width: "8%"}}>{this.props.t("lastLap")}</th>
                                        <th className={"App_header"} style={{width: "8%"}}>{this.props.t("bestLap")}</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.tableRows}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            );
        } else {
            return (
                <div/>
            );
        }
    }
}

export default withTranslation("translations")(withCookies(PopoutLiveTiming));
